function trimSlash(s: string) { return s.replace(/\/+$/, ''); }
const rawApiBase = trimSlash(import.meta.env.VITE_CHAT_API_BASE || '/v1');
// chat-core builds requests with `new URL(path, baseUrl)`, so base-url MUST be
// absolute. A relative default (/v1, proxied in dev) is resolved against the
// page origin → e.g. http://localhost:3000/v1.
const origin = typeof window !== 'undefined' ? window.location.origin : '';
const apiBase = /^https?:\/\//.test(rawApiBase) ? rawApiBase : `${origin}${rawApiBase}`;
function defaultRealtime() {
  if (!apiBase) return '';
  return `${apiBase.replace(/^http/, 'ws')}/realtime`;
}
export const config = {
  apiBase,
  realtimeUrl: import.meta.env.VITE_CHAT_REALTIME_URL || defaultRealtime(),
  // All served by axchat-identity, which owns the OAuth client: the client id,
  // the IdP, the scopes, the redirect URI and the PKCE verifier. Fixed by the
  // axon-web-demo chart's route table (`/axon/oauth` → axchat-identity), and in
  // dev by the Vite proxy, so none is configuration.
  loginPath: '/axon/oauth/login',
  tokenPath: '/axon/oauth/token',
  // Spends the HttpOnly refresh cookie set by the token exchange. The cookie is
  // scoped to /axon/oauth, so this must stay under that prefix.
  refreshPath: '/axon/oauth/refresh',
  // Clears identity's refresh cookie on sign-out.
  logoutPath: '/axon/oauth/logout',
};
